import { z } from "zod";

export const RESUME_UPLOAD_MAX_BYTES = 5 * 1024 * 1024;
export const RESUME_UPLOAD_TTL_MS = 30 * 60 * 1000;
export const RESUME_UPLOAD_QUERY_PARAM = "resume_upload";

const uploadIdSchema = z.string().uuid();
const fileMetadataSchema = z.object({
  name: z.string().trim().min(1).max(255).regex(/\.pdf$/i),
  type: z.enum(["application/pdf", "application/octet-stream", ""]),
  size: z.number().int().positive().max(RESUME_UPLOAD_MAX_BYTES),
});

export type ResumeUploadErrorKey =
  | "HOME_RESUME_UPLOAD_INVALID"
  | "HOME_RESUME_UPLOAD_TOO_LARGE"
  | "HOME_RESUME_UPLOAD_STORAGE_ERROR"
  | "HOME_RESUME_UPLOAD_MISSING"
  | "HOME_RESUME_UPLOAD_PARSE_ERROR";

export class ResumeUploadError extends Error {
  constructor(public readonly messageKey: ResumeUploadErrorKey) {
    super(messageKey);
    this.name = "ResumeUploadError";
  }
}

export function getResumeUploadId(search: string): string | null {
  const result = uploadIdSchema.safeParse(
    new URLSearchParams(search).get(RESUME_UPLOAD_QUERY_PARAM)
  );
  return result.success ? result.data : null;
}

export function resumeUploadHref(path: "/sign-in" | "/sign-up" | "/import" | "/builder", id: string): string {
  return `${path}?${RESUME_UPLOAD_QUERY_PARAM}=${uploadIdSchema.parse(id)}`;
}

export async function validateResumeUpload(file: File): Promise<void> {
  if (file.size > RESUME_UPLOAD_MAX_BYTES) {
    throw new ResumeUploadError("HOME_RESUME_UPLOAD_TOO_LARGE");
  }
  if (!fileMetadataSchema.safeParse(file).success) {
    throw new ResumeUploadError("HOME_RESUME_UPLOAD_INVALID");
  }
  // Check the bytes as well as the extension before keeping a file in the browser.
  if (await file.slice(0, 5).text() !== "%PDF-") {
    throw new ResumeUploadError("HOME_RESUME_UPLOAD_INVALID");
  }
}
